// gatsby-browser.js
import "./src/global.css"
import { loadCallRail, rescanCallRail } from "./src/utils/callrail"

const updateSenseiLinks = () => {
  const storedUtm = sessionStorage.getItem("utmParams")
  if (!storedUtm) return

  const links = document.querySelectorAll('a[href*="sensei3d"]')
  links.forEach(link => {
    const currentUrl = link.getAttribute("href")
    if (!currentUrl || currentUrl.includes(storedUtm)) return

    const newUrl = currentUrl.includes("?")
      ? `${currentUrl}&${storedUtm}`
      : `${currentUrl}?${storedUtm}`

    link.setAttribute("href", newUrl)
  })
}

export const onClientEntry = () => {
  loadCallRail().catch(error => {
    console.warn(error.message)
  })
}

export const onRouteUpdate = ({ location }) => {
  // Always remove revamp CSS on route change. ProductTemplate reloads it when
  // the 3D modal opens, so it must not leak onto the destination page.
  const cssLink = document.querySelector(
    'link[href="/static/css/main.5b737e1c.css"]'
  )
  if (cssLink) {
    cssLink.remove()
  }
  document.body.classList.remove("revamp-modal-open")

  const searchParams = new URLSearchParams(location.search)
  const utmParams = []

  for (const [key, value] of searchParams.entries()) {
    if (key.startsWith("utm_") || key === "fbclid") {
      utmParams.push(`${key}=${value}`)
    }
  }

  if (utmParams.length > 0) {
    sessionStorage.setItem("utmParams", utmParams.join("&"))
  }

  // onRouteUpdate runs after Gatsby commits the new page. The animation frame
  // lets React finish any same-commit DOM work before third parties scan it.
  requestAnimationFrame(() => {
    updateSenseiLinks()
    rescanCallRail()
  })
}

export const onPreRouteUpdate = () => {
  // No pre-route action is required.
}
